import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    isLoading: false,
    theme: "light",
    heading: "",
    isFormLoading: false,
    breadcrumb: [],
    badlaOptions: [],
    internetConnection: true,
    modalOptions: {
      isOpen: false,
      rowData: {},
      name: "",
      modalTitle: "",
    },
    canvasOptions: {
      isOpen: false,
      rowData: {},
      name: "",
      canvasTitle: "",
    },
  },
  reducers: {
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setTheme(state, action) {
      state.theme = action.payload;
    },
    setHeading(state, action) {
      state.heading = action.payload;
    },
    setFormSubmitLoading(state, action) {
      state.isFormLoading = action.payload;
    },
    addBreadcrumb(state, action) {
      state.breadcrumb = action.payload;
    },
    setBadlaOptions(state, action) {
      state.badlaOptions = action.payload;
    },
    setInternetConnection(state, action) {
      state.internetConnection = action.payload;
    },
    setModalOption(state, action) {
      state.modalOptions = action.payload;
    },
    clearModalOption(state) {
      state.modalOptions = {
        isOpen: false,
        rowData: {},
        name: "",
        modalTitle: "",
      };
    },
    setCanvasOption(state, action) {
      state.canvasOptions = action.payload;
    },
    clearCanvasOption(state) {
      state.canvasOptions = {
        isOpen: false,
        rowData: {},
        name: "",
        canvasTitle: "",
      };
    },
  },
});

export const uiActions = uiSlice.actions;
export default uiSlice;
